import React from "react";
import "./PolicyList.css";

const completionStatusOptions = [
  "Implemented",
  "Partially Implemented",
  "Draft",
  "Not Defined"
];

// 🎯 Couleur par statut
const getStatusClass = (status) => {
  switch (status) {
    case "Implemented": return "policy-status-green";
    case "Partially Implemented":
    case "Draft": return "policy-status-amber";
    case "Not Defined":
    default: return "policy-status-red";
  }
};

// 📚 Ordre ISO des domaines
const DOMAIN_ORDER = [
  "Governance",
  "Access Control",
  "Human Resources",
  "Asset Protection",
  "Development Security",
  "Cloud & Supply Chain",
  "Incident Management",
  "Business Continuity",
  "Compliance",
  "Uncategorized"
];

export default function PolicyList({ policies, isEditableUser, handleChange, inputRefs }) {
  const grouped = policies.reduce((acc, p, index) => {
    const domain = p.domain || "Uncategorized";
    if (!acc[domain]) acc[domain] = [];
    acc[domain].push({ ...p, _index: index });
    return acc;
  }, {});

  const unlockField = (index, field) => {
    if (!isEditableUser) return;
    const key = `${index}-${field}`;
    setTimeout(() => {
      inputRefs.current[key]?.focus?.();
    }, 0);
  };

  return (
    <div className="policy-wrapper">
      <div className="policy-table-responsive">
        <table className="policy-table">
          <thead className="policy-thead">
            <tr>
              <th>Clause</th>
              <th>Policy</th>
              <th>Description</th>
              <th>Status</th>
              <th>Last Review</th>
            </tr>
          </thead>
          <tbody>
            {DOMAIN_ORDER
              .filter(domain => grouped[domain])
              .map(domain => (
                <React.Fragment key={domain}>
                  <tr className="domain-row">
                    <td colSpan="5" className="domain-label">{domain}</td>
                  </tr>
                  {grouped[domain].map((p, i) => {
                    const idx = p._index;
                    return (
                      <tr key={`${domain}-${i}`}>
                        <td>{p.clause}</td>
                        <td>{p.policy}</td>
                        <td>{p.description}</td>
                        <td>
                          <select
                            className={`policy-select ${getStatusClass(p.completion_status)}`}
                            value={p.completion_status}
                            disabled={!isEditableUser}
                            onChange={e => handleChange(idx, "completion_status", e.target.value)}
                          >
                            {completionStatusOptions.map((status, j) => (
                              <option key={j} value={status}>{status}</option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <input
                            type="date"
                            className="policy-input"
                            value={p.last_review || ""}
                            ref={el => inputRefs.current[`${idx}-last_review`] = el}
                            onClick={() => unlockField(idx, "last_review")}
                            onChange={e => handleChange(idx, "last_review", e.target.value)}
                            disabled={!isEditableUser}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </React.Fragment>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
